"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const custom_1 = __importDefault(require("../../../client/form_components/checkboxes/custom"));
const form_select_1 = __importDefault(require("../../../client/form_components/selects/form_select"));
const icon_1 = __importDefault(require("../../../client/icon"));
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const graphql_1 = require("../../../requests/graphql");
const dispatchers_1 = require("../../../utility/dispatchers");
const Form_1 = require("./Form");
const inputs_css_1 = __importDefault(require("../../../styles/global_ui/inputs.css"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const styles_css_1 = __importDefault(require("./styles.css"));
exports.c = {
    column: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter30}`,
    row: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.gutter15} `,
    details: `${util_css_1.default.bgFog} ${layout_css_1.default.fullWidth} ${typography_css_1.default.charcoal} ${styles_css_1.default.details}`,
    summary: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.flexCenterItems} ${typography_css_1.default.bold} ${styles_css_1.default.summary}`,
    marker: styles_css_1.default.marker,
    previousSlug: `${layout_css_1.default.marginBottom30} ${typography_css_1.default.error}`,
    content: `${layout_css_1.default.flexColumn} ${layout_css_1.default.padding15}`,
    addButton: `${layout_css_1.default.marginLeftAuto}`,
    removed: `${util_css_1.default.disabled}`,
    disabled: `${layout_css_1.default.marginBottom25} ${typography_css_1.default.error}`,
};
const Survey = ({ errors, form, giveaway, handleUpdate, survey, isSubmitting, options, pendingChanges, setErrors, }) => {
    const [isSurveyRemoved, setIsSurveyRemoved] = (0, react_1.useState)(false);
    const [versionOptions, setVersionOptions] = (0, react_1.useState)();
    const [isVersionInUse, setIsVersionInUse] = (0, react_1.useState)(false);
    const contestLaunched = giveaway.status === 'in_progress' || giveaway.status === 'completed';
    const isAddingSurvey = !survey;
    const editingProhibited = contestLaunched && !isAddingSurvey;
    const previousSurvey = giveaway?.surveys?.find((editingSurvey) => editingSurvey.id === survey?.id);
    const updatedSurvey = form?.surveys?.find((editingSurvey) => editingSurvey.id === survey?.id);
    const previouslyEditedSurveys = form?.surveys?.filter((p) => p?.id !== survey?.id) || [];
    const fieldId = `surveys-${previousSurvey?.id || updatedSurvey?.id}`;
    const parseSurvey = ({ value }) => {
        if (!value)
            return '';
        const data = JSON.parse(value);
        // a survey must have a title otherwise, we won't be able to find the footer and insert our own nav buttons.
        if (!data.title) {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: 'A survey must contain a title',
                type: 'error',
            });
            return '';
        }
        // Loop pages to find elements (questions). Check type and add corresponding itemComponent
        data.pages.forEach((page) => {
            page.elements.forEach((element) => {
                if (element.type === 'radiogroup') {
                    return (element['itemComponent'] = 'RadioGroup');
                }
                else if (element.type === 'rating') {
                    delete element.rateType;
                    return (element['itemComponent'] = 'RobotRating');
                }
            });
        });
        return JSON.stringify(data);
    };
    const updateField = ({ field, value }) => {
        let data;
        if (field === 'content') {
            data = parseSurvey({ value });
        }
        handleUpdate({
            name: 'surveys',
            value: [
                ...previouslyEditedSurveys,
                { ...updatedSurvey, id: previousSurvey?.id, [field]: data || value },
            ],
        });
    };
    const handleVersionBlur = ({ target }) => {
        setIsVersionInUse(versionOptions?.some(({ label }) => label === target.value));
    };
    const handleDelete = () => {
        setIsSurveyRemoved(true);
        handleUpdate({
            name: 'surveys',
            value: [
                ...previouslyEditedSurveys,
                { ...updatedSurvey, id: previousSurvey?.id, _destroy: true },
            ],
        });
    };
    const handleCheckboxUpdate = ({ placement, checked }) => {
        const prevValue = pendingChanges.has(`${fieldId}-placement`) ? updatedSurvey?.placements : previousSurvey?.placements;
        let updatedValue;
        if (!prevValue) {
            updatedValue = [placement];
        }
        else {
            updatedValue = checked ? [...prevValue, placement] : prevValue?.filter((place) => place !== placement);
        }
        updateField({ field: 'placements', value: updatedValue });
    };
    (0, react_1.useEffect)(() => {
        if (isVersionInUse) {
            const error = {
                [`${fieldId}-version`]: 'Can not reuse a previous version for this survey',
            };
            setErrors(error);
        }
    }, [fieldId, isVersionInUse, setErrors]);
    (0, react_1.useEffect)(() => {
        if (updatedSurvey?.survey_slug) {
            (0, graphql_1.graphMutate)({ t: 'get_survey_versions_by_slug' }, { survey_slug: updatedSurvey.survey_slug })
                .then(({ survey_slug_versions }) => {
                const opts = survey_slug_versions.map(({ version }) => ({
                    label: version.toString(),
                    value: version.toString(),
                }));
                setVersionOptions(opts);
            })
                .catch((err) => (0, error_handler_1.default)('fetch all survey slugs versions for slug: ', err));
        }
        else {
            setVersionOptions([]);
        }
    }, [updatedSurvey?.survey_slug]);
    return (react_1.default.createElement("div", { className: `${layout_css_1.default.flex} ${layout_css_1.default.gutter60} ${isSurveyRemoved ? exports.c.removed : ''}` },
        react_1.default.createElement("div", { className: layout_css_1.default.fullWidth },
            editingProhibited && (react_1.default.createElement("div", { className: exports.c.disabled }, "Cannot edit surveys once a Giveaway has launched")),
            react_1.default.createElement(form_select_1.default, { key: form?.surveys?.length, creatableOpts: { creatable: true }, disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-survey_slug`], helperText: "The slug is our unique name for surveys. They cannot contain spaces, please use underscores or hyphens.", label: "Slug", name: "survey_slug", onSelectedChange: (opt) => {
                    updateField({
                        field: 'survey_slug',
                        value: opt?.value,
                    });
                }, options: options, placeholder: "Select survey slug or create a new one", value: pendingChanges.has(`${fieldId}-survey_slug`)
                    ? updatedSurvey?.survey_slug || previousSurvey?.survey_slug
                    : previousSurvey?.survey_slug || '' }),
            versionOptions?.length > 0 && (react_1.default.createElement("div", { className: exports.c.previousSlug },
                "Reusing a previous survey? Great! Be sure to increment the version number below. Here is a list of the previous versions. This new survey can not match any of the previous versions.",
                react_1.default.createElement("ul", null, versionOptions.map((option) => (react_1.default.createElement("li", { key: option.label }, option.label)))))),
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-version`], helperText: "For reoccurring surveys that we want to track changes over time. You may increment by full or decimal values. Most surveys should start at version 1.0", label: "Version", name: "version", onBlur: handleVersionBlur, onChange: ({ target: { value } }) => updateField({
                    field: 'version',
                    value: parseFloat(value),
                }), placeholder: "1.0", step: ".1", type: "number", value: pendingChanges.has(`${fieldId}-version`)
                    ? updatedSurvey?.version
                    : previousSurvey?.version || '' }),
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-description`], helperText: "This is for admins only. It is a description to help remind you what this survey is for.", label: "Description (optional)", name: "description", onChange: ({ target: { value } }) => updateField({ field: 'description', value }), placeholder: "A survey regarding basic personal demographics", value: pendingChanges.has(`${fieldId}-description`)
                    ? updatedSurvey?.description
                    : previousSurvey?.description || '' }),
            react_1.default.createElement("div", { className: `${layout_css_1.default.marginBottom30}` },
                react_1.default.createElement("div", { className: inputs_css_1.default.label }, "Placement (optional)"),
                react_1.default.createElement("div", { className: `${inputs_css_1.default.help} ${layout_css_1.default.marginBottom10}` }, "If you want this survey to appear on the Registration view, please select this checkbox. Otherwise, it will appear under the Surveys tab."),
                react_1.default.createElement("div", { className: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter15}` },
                    react_1.default.createElement(custom_1.default, { disabled: isSubmitting || editingProhibited, isChecked: pendingChanges.has(`${fieldId}-placement`)
                            ? updatedSurvey?.placements?.includes('registration')
                            : previousSurvey?.placements?.includes('registration') || false, label: "Registration Tab", name: "registration", onChange: (checked) => handleCheckboxUpdate({ placement: 'registration', checked }) }))),
            react_1.default.createElement(basic_form_input_1.default, { key: `${fieldId}-content`, disabled: isSubmitting || editingProhibited, element: "textarea", label: "Content", name: "content", onChange: ({ target: { value } }) => updateField({ field: 'content', value }), placeholder: `{
            "title": "NPS Survey Question",
            "pages": [{
              "name": "page1",
              "elements": [{
                "type": "comment",
                "name": "disappointing_experience",
                "title": "Please let us know why you had such a disappointing experience with our product"
              }]
            }]
          }`, rows: "10", value: pendingChanges.has(`${fieldId}-content`)
                    ? updatedSurvey?.content
                    : JSON.stringify(previousSurvey?.content) || '' }),
            survey?.id && (react_1.default.createElement("div", { className: (exports.c.row, layout_css_1.default.flexEndItems) },
                contestLaunched && (react_1.default.createElement("span", { className: typography_css_1.default.bodyS }, "Cannot be removed once a Giveaway has launched")),
                react_1.default.createElement(base_1.default, { className: layout_css_1.default.marginLeftAuto, colorStyle: "danger", disabled: contestLaunched, onClick: handleDelete, size: "md" }, "Delete"))))));
};
const Surveys = ({ errors, form, giveaway, handleUpdate, isSubmitting, pendingChanges, setIsSubmitting, setErrors, options, }) => {
    const surveys = giveaway.surveys || [];
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Surveys"),
        react_1.default.createElement("div", { className: Form_1.c.form },
            react_1.default.createElement("p", null,
                "You can create the json to be entered by going to",
                ' ',
                react_1.default.createElement("a", { href: "https://surveyjs.io/survey-creator/examples/set-how-survey-configuration-changes-are-saved/reactjs", rel: "noreferrer", target: "_blank" }, "SurveyJs creator"),
                ". The title of the survey along with any descriptions will come from the editor in SurveyJS."),
            react_1.default.createElement("div", { className: exports.c.column },
                surveys.map((survey) => (react_1.default.createElement("details", { key: survey.id, className: exports.c.details },
                    react_1.default.createElement("summary", { className: exports.c.summary },
                        survey.survey_slug,
                        react_1.default.createElement(icon_1.default, { className: exports.c.marker, name: "arrow-down", size: "16" })),
                    react_1.default.createElement("div", { className: exports.c.content },
                        react_1.default.createElement(Survey, { errors: errors, form: form, giveaway: giveaway, handleUpdate: handleUpdate, isSubmitting: isSubmitting, options: options, pendingChanges: pendingChanges, setErrors: setErrors, setIsSubmitting: setIsSubmitting, survey: survey }))))),
                react_1.default.createElement("details", { className: exports.c.details, open: surveys.length === 0 },
                    react_1.default.createElement("summary", { className: exports.c.summary },
                        "Add",
                        ' ',
                        surveys.length > 0 ? 'Another' : 'A',
                        ' ',
                        "Survey",
                        react_1.default.createElement(icon_1.default, { className: exports.c.marker, name: "arrow-down", size: "16" })),
                    react_1.default.createElement("div", { className: exports.c.content },
                        react_1.default.createElement(Survey, { key: "new-survey", errors: errors, form: form, giveaway: giveaway, handleUpdate: handleUpdate, isSubmitting: isSubmitting, options: options, pendingChanges: pendingChanges, setErrors: setErrors, setIsSubmitting: setIsSubmitting })))))));
};
exports.default = Surveys;
